import React, { FC, useState } from 'react';
import { DPDPoint } from "../../types/types";
import { useTranslation } from "react-i18next";

interface RentalPointDetailsInterface{
    point: DPDPoint,
    selected: boolean,
    hovered: boolean
}

const RentalPointDetails: FC<RentalPointDetailsInterface> = ({point, selected, hovered}) => {
    const {t} = useTranslation();
    const days = point?.schedule?.filter((day) => {
        return day.openAfternoon !== '00:00' ||
            day.closeAfternoon !== '00:00' ||
            day.openMorning !== '00:00' ||
            day.closeMorning !== '00:00'
    }) || [];
    return (
        <div
            className={"select-none rounded-md  flex flex-col xl:flex-row flex-1 items-start p-1 transition duration-500 ease-in-out transform hover:-translate-y-2 border-2 mt-3 hover:shadow-2xl" +
                (hovered ? " shadow-2xl -translate-y-2" : "") +
                (selected ? " border-orange-400" : " border-orange-400")
            }>
            <div className="w-full xl:w-1/2">
                <div className="w-full flex-1 pl-1 mr-16 font-medium truncate">
                    {point.address}
                </div>
                <div className="w-full flex-1 pl-1 mr-16 text-slate-600">
                    <div className="font-medium">
                        {point.company}
                    </div>
                </div>
            </div>
            <div className="w-full xl:w-1/2">
                <div className="w-full">
                    <ul className="p-0">
                        {days.map((day) => {
                            return <li className="pl-1 grid grid-cols-5" key={day.weekday}>
                                <b>{t("weekdays." + day.weekday)}</b>
                                {day.openMorning !== '00:00' && <span className="col-span-2">
                                                {day.openMorning}-{day.closeMorning}
                                            </span>}
                                {day.openAfternoon !== '00:00' && <span className="col-span-2">
                                                {day.openAfternoon}-{day.closeAfternoon}
                                            </span>}
                            </li>
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default RentalPointDetails;
